import { QuestionData, type CrmData } from '@playbooks/action-cards-utils/src'

import { processReplacements } from '../utils/processReplacements'

function replaceWidgetStaticFields(staticFields: CrmData, questionsWithCode: QuestionData[]) {
  if (staticFields) {
    const stringifiedFields = processReplacements(JSON.stringify(staticFields), questionsWithCode)!
    staticFields = JSON.parse(stringifiedFields)
  }

  return staticFields
}

export default replaceWidgetStaticFields
